<template>
  <div>
    <el-upload
      class="upload-demo"
      drag
      :action="commonServer.uploadDicom"
      :accept="uploadInfo.accept"
      :headers="{ Authorization: token }"
      :multiple="uploadInfo.multiple"
      :file-list="fileList"
      :show-file-list="uploadInfo.show"
      :on-progress="uploadProgress"
      :on-change="uploadChange"
      :on-success="uploadSuccess"
      :on-remove="uploadRemove"
      :on-preview="handlePreview"
      :on-error="uploadError"
      :before-upload="uploadBefore">
      <div class="el-upload__text">
          将文件拖到此处，或<em>点击上传</em>
          <p>{{uploadInfo.tip}}</p>
      </div>
    </el-upload>
    <!-- <el-progress :percentage="progress" /> -->
  </div>
</template>

<script>
import { commonServer } from '@/api/api'
export default {
  props: {
    uploadInfo: {
      type: Object
    }
  },
  data () {
    return {
      commonServer,
      progress: 0, // 上传进度
      fileInfo: {...this.uploadInfo},
      fileList: this.uploadInfo.fileList,
      token: window.localStorage.getItem('token'),
      hasShownUploadingMessage: false // 新增标志位，用于判断是否已经显示过提
    }
  },
  methods: {
    clearFormList () {
      this.fileList = this.uploadInfo.fileList
    },
    // 上传进度回调
    uploadProgress(event, file, fileList) {
      this.progress = Math.round((event.percent || 0));
    },
    uploadChange (file, fileList) {
      if (!this.hasShownUploadingMessage) {
        this.$message.warning('文件正在上传中，请稍后再来查看！')
        this.hasShownUploadingMessage = true
      }
      this.$emit('uploadres', false);
      if (!this.uploadInfo.multiple) {
        if (fileList.length > 0) {
          this.fileList = [fileList[fileList.length - 1]] // 展示最后一次选择的文件
        }
      }
    },
    /**
     * 上传结果处理
     * @function uploadSuccess
     * @param  {Object} response 上传返回结果
     */ 
    uploadSuccess (response, file) {
      if (response.code !== '0') {
        this.$message.error(response.message)
        return
      }
      file.url = response.data.fileUrl
      // this.$emit('uploadres', {response, file})
    },
    handlePreview (file) {
      window.open(file.url)
    },
    uploadRemove(file, fileList) {
      // 文件移除后的回调
      this.$emit('uploadres', {response: null, file: null});
    },
    /**
     * 上传前的判断
     * @function uploadBefore
     * @return {Boolean}
     */
    uploadBefore (response) {
      var fileSize = response.size / 1024 / 1024 < this.uploadInfo.fileSize;// 控制大小修改50的值即可
      if (!fileSize) {
        this.$message.error(`文件大小不能超过${this.uploadInfo.fileSize}MB`)
        return false;
      }
    },
    /**
     * 上传异常处理
     * @function uploadError
     * @param  {Object|String} err 上传异常信息
     */
    uploadError () {}
  }
}
</script>

<style lang='scss'>
.upload-demo {
  .el-upload {
    width: 100%;
  }
  /* 隐藏进度条 */
//   .el-upload-list .el-upload-list__item .el-progress--line {
//     display: none;
//   }
  .el-upload-dragger {
    width: 100%;
    height: 120px;
  }
  .el-upload__text {
    padding-top: 35px;
    font-size: 16px;
    line-height: 28px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/UploadDicom/index.vue